/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Min_AmountInputs */

const en_orders_min_amount = /** @type {(inputs: Orders_Min_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min amount`)
};

const es_orders_min_amount = /** @type {(inputs: Orders_Min_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monto min`)
};

/**
* | output |
* | --- |
* | "Min amount" |
*
* @param {Orders_Min_AmountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_min_amount = /** @type {((inputs?: Orders_Min_AmountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Min_AmountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_min_amount(inputs)
	return es_orders_min_amount(inputs)
});